import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/images/logo_title.png'


const _hoisted_1 = ["index", "href"]
const _hoisted_2 = ["index", "href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "menu-collapse" }
const _hoisted_6 = { class: "flex header" }
const _hoisted_7 = { class: "currency" }
const _hoisted_8 = { class: "currency_unit" }
const _hoisted_9 = { class: "title-avatar" }
const _hoisted_10 = { class: "main-container" }
const _hoisted_11 = { class: "tips-m" }
const _hoisted_12 = { class: "dialog-footer" }

import { ref, computed, onMounted, nextTick, onUnmounted } from "vue";
import usePiniaStore from "@/store/index";
import { useRouter, useRoute } from "vue-router";
import {
  ElContainer,
  ElMenu,
  ElSubMenu,
  ElMenuItem,
  ElButton,
  ElScrollbar,
  ElHeader,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElMain,
  ElDialog,
  ElDropdown,
  ElDropdownMenu,
  ElDropdownItem,
  ElNotification,
} from "element-plus";
import axios, { ResponseType } from "@/utils/request";
import SvgIcon from "@/components/SvgIcon.vue";

interface messageType {
  id: number;
  title: string;
  content: string;
  readStatus: number; //读状态：1-已读，0-未读
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Layout',
  setup(__props) {

const { cityListStore, userStore, paymentStore } = usePiniaStore();
const router = useRouter();
const route = useRoute();
const isCollapse = ref(false);
const dialogVisible = ref(false);

// 读取 vuex
// const userInfo = computed(() => userStore.personInfo);
// const selectMenus = computed(() => store.state.user.selectMenus);
// const menuList = computed(() => store.state.user.menus);
// const breadcrumbList = computed(() => userStore.breadcrumbList);
// const includeComponent = computed(() => store.getters["user/includeComponent"]);

const userInfo = computed(() => userStore.personInfo);
const selectMenus = computed(() => userStore.selectMenus);
const menuList: any = computed(() => userStore.menus);
const breadcrumbList = computed(() => userStore.breadcrumbList);
const includeComponent = computed(() => userStore.includeComponent);
const msgIdList: any = ref([]);

// 保存BroadcastChannel实例的引用，用于清理
let broadcastChannel = ref<BroadcastChannel | null>(null);

onMounted(() => {
  const defaultV = route.meta.from as string;
  userStore.updateSelectMenus(defaultV);
  // 获取用户的权限和初始化菜单栏
  userStore.getMyRole();
  cityListStore.getCityList();
  // 获取用户的信息
  userStore.getPersonInfo();
  userStore.queryAgentUnitList();

  paymentStore.getPaymentOptionList(); // 更新交易方式
  // 手动刷新页面，更新菜单命中

  queryInnerMessage();

  // 使用 nextTick 确保组件完全挂载后再设置监听器
  nextTick(() => {
    // 增加额外延迟，确保所有同步代码执行完毕
    setupBroadcastListener();
  });
});

onUnmounted(() => {
  // 组件销毁时清理BroadcastChannel
  if (broadcastChannel.value) {
    broadcastChannel.value.close();
    broadcastChannel.value = null;
  }
});

/**
 * 设置 BroadcastChannel 监听器
 * 使用延迟处理机制确保消息有序性，避免与页面初始化产生竞态条件
 */
const setupBroadcastListener = () => {
  const senderTabId = sessionStorage.getItem("senderTabId");
  console.log("🚀 结束:", senderTabId);

  // 如果已存在channel实例，先清理
  if (broadcastChannel.value) {
    broadcastChannel.value.close();
    broadcastChannel.value = null;
  }

  broadcastChannel.value = new BroadcastChannel("reload_control");
  broadcastChannel.value.addEventListener("message", (event) => {
    if (event.data.type === "RELOAD_OTHER_TABS") {
      // 如果不是发送者，则处理重新加载指令
      if (event.data.senderTabId !== senderTabId) {
        console.log("收到重新加载指令，正在重新加载页面");
        location.reload(); // 如需要可以启用
      }
    }
  });
};

const queryInnerMessage = async () => {
  const res: ResponseType = await axios.get("/facade/sale/sitemsg/user/page");
  if (res.code === 0) {
    let message = "";
    res.data?.list.forEach((item: messageType) => {
      if (item.readStatus === 0 && msgIdList.value.length < 10) {
        message += `<p>${item.title}</p>`;
        msgIdList.value.push(item.id);
      }
    });
    if (msgIdList.value.length > 0) {
      ElNotification({
        title: "未读消息通知",
        message: message,
        dangerouslyUseHTMLString: true,
        position: "bottom-right",
        duration: 0,
        onClose: closeNotices,
        onClick: checkMsg,
      });
    }
  }
};

// 关闭消息通知弹窗-标记消息通知为已读
const closeNotices = async () => {
  const res: ResponseType = await axios.post("/facade/sale/sitemsg/user/read", {
    idList: msgIdList.value,
  });
  if (res.code === 0) {
    console.log("消息通知已读");
  }
};

const checkMsg = () => {
  router.push("/home/person-center");
};

const handleCollapse = () => {
  isCollapse.value = !isCollapse.value;
};

const handleselect = (key: string, keyPath: string[]) => {
  if (key === "/") return;
  const path = keyPath.join("/");
  // 打开查询+表单页面的刷新
  cityListStore.updateNeedReflash(true);
  // 点击同一个菜单
  if (router.currentRoute.value.path === path) {
    cityListStore.updateReflashNum();
  } else {
    router.push(path);
  }
};

const handleGo = (val: string) => {
  if (val === "a") {
    router.push("/home/person-center");
  } else {
    dialogVisible.value = true;
  }
};
const confirm = async () => {
  // const res: any = await axios.post("/facade/sale/login/out");
  const res: any = await axios.post("/facade/sale/agency/user/signOut");
  if (res.code === 0) {
    router.replace(`/login`); // 主动退出
    sessionStorage.setItem("redirectUrl", ""); // 清空
    localStorage.setItem("token_value", "");
  }
};
// const handleChange = (val: string) => {
//   const language: any = localStorage.getItem("language") || "cn";
//   if (val !== language) {
//     localStorage.setItem("language", val);
//     location.reload();
//   }
// };

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ElContainer), { class: "content-layout" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElMenu), {
          class: "menu-list",
          "default-active": selectMenus.value,
          "unique-opened": true,
          collapse: isCollapse.value,
          onSelect: handleselect
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElScrollbar), { class: "menu-scrollbar" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElMenuItem), {
                  index: "/home/person-center",
                  class: "menu_max_width"
                }, {
                  title: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("img", {
                      class: "logo_title",
                      src: _imports_0
                    }, null, -1)
                  ]))]),
                  default: _withCtx(() => [
                    _createVNode(SvgIcon, {
                      name: "logo",
                      size: 26,
                      color: "#fff"
                    })
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item) => {
                  return (_openBlock(), _createBlock(_unref(ElSubMenu), {
                    key: item.path,
                    index: item.path,
                    class: _normalizeClass({
              hideIcon: isCollapse.value,
              isLine: isCollapse.value && _unref(route).path.includes(item.path),
            })
                  }, {
                    title: _withCtx(() => [
                      _createVNode(SvgIcon, {
                        name: item.meta.icon,
                        size: 16,
                        color: "#fff"
                      }, null, 8, ["name"]),
                      _withDirectives(_createElementVNode("span", { style: {"margin-left":"4px"} }, _toDisplayString(item.meta.title), 513), [
                        [_vShow, !isCollapse.value]
                      ])
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children.filter((a) => !a.meta.hidden), (v, i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: v.path + i
                        }, [
                          (v.children?.length > 0)
                            ? (_openBlock(), _createBlock(_unref(ElSubMenu), {
                                key: 0,
                                index: v.path
                              }, {
                                title: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(v.meta.title), 1)
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.children.filter((a) => !a.meta.hidden), (vv) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: vv.path
                                    }, [
                                      (vv.meta.target === '_blank')
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            index: vv.path,
                                            href: '/' + vv.path
                                          }, [
                                            (_openBlock(), _createBlock(_unref(ElMenuItem), {
                                              key: vv.path
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(vv.meta.title), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          ], 8, _hoisted_1))
                                        : (_openBlock(), _createElementBlock("a", {
                                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                                            onDragstart: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                                            index: vv.path,
                                            key: vv.path,
                                            href: item.path + '/' + v.path + '/' + vv.path
                                          }, [
                                            (_openBlock(), _createBlock(_unref(ElMenuItem), {
                                              index: vv.path,
                                              key: vv.path
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(vv.meta.title), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["index"]))
                                          ], 40, _hoisted_2))
                                    ]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["index"]))
                            : (v.meta.target === '_blank')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  href: '/' + v.path,
                                  target: "_blank"
                                }, [
                                  _createVNode(_unref(ElMenuItem), null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(v.meta.title), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 8, _hoisted_3))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 2,
                                  href: item.path + '/' + v.path,
                                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                                  onDragstart: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                                }, [
                                  _createVNode(_unref(ElMenuItem), {
                                    index: v.path
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(v.meta.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["index"])
                                ], 40, _hoisted_4))
                        ], 64))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["index", "class"]))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(ElButton), {
                onClick: handleCollapse,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(SvgIcon, {
                    name: "expand",
                    size: 24,
                    color: "#fff"
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["default-active", "collapse"]),
        _createVNode(_unref(ElContainer), { class: "layout-container" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElHeader), { class: "layout-header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(ElBreadcrumb), { separator: "/" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElBreadcrumbItem), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("home", "首页")), 1)
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbList.value, (item, index) => {
                        return (_openBlock(), _createBlock(_unref(ElBreadcrumbItem), {
                          key: item.path
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass({ isActive: index === breadcrumbList.value.length - 1 })
                            }, _toDisplayString(item.title), 3)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, " 【" + _toDisplayString(userInfo.value.agencyCode) + "】" + _toDisplayString(userInfo.value.agencyName), 1),
                    _createVNode(_unref(ElDropdown), {
                      placement: "bottom-end",
                      onCommand: handleGo
                    }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_unref(ElDropdownMenu), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElDropdownItem), {
                              command: "a",
                              class: "person_dropdown_item"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("userCenter", "个人中心")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElDropdownItem), {
                              command: "b",
                              class: "person_dropdown_item"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("logout", "退出登录")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(ElButton), { class: "flex person" }, {
                          default: _withCtx(() => [
                            _createVNode(SvgIcon, {
                              name: "avatar",
                              size: 24
                            }),
                            _createElementVNode("span", _hoisted_9, " 【" + _toDisplayString(userInfo.value.account) + "】" + _toDisplayString(userInfo.value.roleName), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(ElMain), { class: "layout-main" }, {
              default: _withCtx(() => [
                _createElementVNode("section", _hoisted_10, [
                  _createVNode(_component_router_view, null, {
                    default: _withCtx(({ Component }) => [
                      Component
                        ? (_openBlock(), _createBlock(_KeepAlive, {
                            key: 0,
                            include: includeComponent.value
                          }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                              key: _ctx.$route.path
                            }))
                          ], 1032, ["include"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(ElDialog), {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogVisible).value = $event)),
      title: _ctx.$t('quitConfirm', '退出确认'),
      width: "30%",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_unref(ElButton), {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("cancel", "取消")), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("confirm", "确定")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t(
          "afterQuitYouNeedToLogInAgain",
          "退出后需重新登录，请确认是否退出当前登录"
        )), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})